var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.template, {
    tag: "component"
  }, [_c('v-container', [_c('v-row', [_c('v-col', [_c('div', {
    staticClass: "contents-area"
  }, [_c('div', {
    staticClass: "contents-area__inner"
  }, [_c('div', {
    staticClass: "tit-wrap tit-wrap--unberline"
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('v-row', {
    staticClass: "row--small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "text": "",
      "small": ""
    },
    on: {
      "click": function click() {
        return _vm.$router.push('/gshop/brand');
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-arrow-left")])], 1)], 1), _c('v-col', [_c('h2', {
    staticClass: "tit"
  }, [_vm._v("상품권 검색")])])], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('v-text-field', {
    staticClass: "w-100 w-md-260px",
    attrs: {
      "name": "search",
      "type": "search",
      "autocomplete": "off",
      "hide-details": "",
      "outlined": "",
      "placeholder": "상품권 검색"
    },
    on: {
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.page = 1;

        _vm.search(true);
      }
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function fn() {
        return [_c('v-icon', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.filter.searchValue,
            expression: "filter.searchValue"
          }],
          staticClass: "mr-1",
          attrs: {
            "size": "28"
          },
          on: {
            "click": function click($event) {
              _vm.filter.searchValue = null;
            }
          }
        }, [_vm._v("mdi-close")]), _c('v-icon', {
          attrs: {
            "size": "28"
          },
          on: {
            "click": function click($event) {
              _vm.page = 1;

              _vm.search(true);
            }
          }
        }, [_vm._v("mdi-magnify")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.filter.searchValue,
      callback: function callback($$v) {
        _vm.$set(_vm.filter, "searchValue", $$v);
      },
      expression: "filter.searchValue"
    }
  })], 1)], 1)], 1), _c('giftcard-detail', {
    attrs: {
      "giftcards": _vm.giftcards,
      "me": _vm.me
    }
  }), _c('div', {
    staticClass: "mt-30px mt-md-70px"
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.pageCount,
      "color": "primary",
      "total-visible": "11"
    },
    on: {
      "input": function input($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 1)], 1)])])], 1), _c('v-dialog', {
    attrs: {
      "max-width": "500",
      "width": _vm.$vuetify.breakpoint ? '50%' : '90%',
      "scrollable": ""
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('a', {
    attrs: {
      "href": "/mypage/profile"
    }
  }, [_c('v-img', {
    attrs: {
      "src": "/images/giftcard-popup3.jpg"
    }
  })], 1), _c('div', {
    staticClass: "popup-layer-foot",
    staticStyle: {
      "display": "flex",
      "background-color": "#424242",
      "padding": "10px"
    }
  }, [_c('v-spacer'), _c('v-btn', {
    staticStyle: {
      "color": "white",
      "font-size": "16px"
    },
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("닫기")])], 1)])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }